import asyncActionType from "../../utils/asyncActionType";

// Locations
export const FETCH_LOCATIONS = asyncActionType("FETCH_MARKET_LOCATIONS");

// Stock Management
export const SCAN_ITEM = asyncActionType("SCAN_ITEM");
export const FETCH_STOCK_LEVELS = asyncActionType("FETCH_STOCK_LEVELS");
export const FETCH_STOCK_ITEMS = asyncActionType("FETCH_STOCK_ITEMS");
export const PROCESS_SHIPMENT = asyncActionType("PROCESS_SHIPMENT");

// Alerts
export const FETCH_ALERTS = asyncActionType("FETCH_ALERTS");
export const RESOLVE_ALERT = asyncActionType("RESOLVE_ALERT");
export const CHECK_EXPIRING = asyncActionType("CHECK_EXPIRING");

// Consumption & Reports
export const FETCH_CONSUMPTION_HISTORY = asyncActionType("FETCH_CONSUMPTION_HISTORY");
export const FETCH_CONSUMPTION_REPORT = asyncActionType("FETCH_CONSUMPTION_REPORT");
export const GENERATE_DAILY_SUMMARY = asyncActionType("GENERATE_DAILY_SUMMARY");

// Stock Adjustment
export const ADJUST_STOCK = asyncActionType("ADJUST_STOCK");

// UI State
export const SET_FIFO_WARNING = "SET_FIFO_WARNING";
export const CLEAR_FIFO_WARNING = "CLEAR_FIFO_WARNING";
export const SET_SCAN_MODE = "SET_SCAN_MODE";
export const CLEAR_SCAN_RESULT = "CLEAR_SCAN_RESULT";